import { t } from 'i18next'
import { z } from 'zod'

export const FIELD_NAMES = {
  EQUIPMENT_NAME: 'name',
  EQUIPMENT_DESCRIPTION: 'description',
  MANUFACTURER: 'manufacturer',
  TIMER_ID: 'timerId',
  IMAGE: 'image',
  QUALITY_CATEGORY: 'qualityCategory',
  IS_UV_EQUIPMENT: 'isUvEquipment',
  NON_UV_CATEGORY: 'nonUvCategory',
  SITE_SESSION_TYPE_IDS: 'siteSessionTypeIds',
  DEFAULT_TIMER_TIME: 'defaultTimerMinutes',
  MINIMUM_TIMER_TIME: 'minTimerMinutes',
  MAXIMUM_TIMER_TIME: 'maxTimerMinutes',
  MINIMUM_DELAY_TIME: 'minDelayMinutes',
  MAXIMUM_DELAY_TIME: 'maxDelayMinutes',
  DEFAULT_DELAY_TIME: 'defaultDelayMinutes',
}

export const DEFAULT_VALUES = {
  [FIELD_NAMES.EQUIPMENT_NAME]: '',
  [FIELD_NAMES.EQUIPMENT_DESCRIPTION]: '',
  [FIELD_NAMES.MANUFACTURER]: '',
  [FIELD_NAMES.TIMER_ID]: '',
  [FIELD_NAMES.QUALITY_CATEGORY]: 'gold',
  [FIELD_NAMES.IS_UV_EQUIPMENT]: true,
  [FIELD_NAMES.NON_UV_CATEGORY]: '',
  [FIELD_NAMES.SITE_SESSION_TYPE_IDS]: [],
  [FIELD_NAMES.DEFAULT_TIMER_TIME]: 15,
  [FIELD_NAMES.MINIMUM_TIMER_TIME]: 5,
  [FIELD_NAMES.MAXIMUM_TIMER_TIME]: 15,
  [FIELD_NAMES.MINIMUM_DELAY_TIME]: 5,
  [FIELD_NAMES.MAXIMUM_DELAY_TIME]: 10,
  [FIELD_NAMES.DEFAULT_DELAY_TIME]: 5,
}

export const VALIDATION_SCHEMA = z
  .object({
    [FIELD_NAMES.EQUIPMENT_NAME]: z.string().min(1, { message: t('errors:forms.required') }),
    [FIELD_NAMES.EQUIPMENT_DESCRIPTION]: z.string().min(1, { message: t('errors:forms.required') }),
    [FIELD_NAMES.MANUFACTURER]: z.string().optional(),
    [FIELD_NAMES.TIMER_ID]: z
      .string()
      .min(1, { message: t('errors:forms.required') })
      .regex(/^\d+$/, {
        message: t('errors:forms.requiredNumber', {
          field: t('checkIn:equipments.addEquipment.timerId'),
        }),
      }),
    [FIELD_NAMES.QUALITY_CATEGORY]: z.string().min(1, { message: t('errors:forms.required') }),
    [FIELD_NAMES.IS_UV_EQUIPMENT]: z.boolean(),
    [FIELD_NAMES.NON_UV_CATEGORY]: z.string().optional(),
    [FIELD_NAMES.SITE_SESSION_TYPE_IDS]: z
      .array(z.string())
      .min(1, { message: t('errors:forms.required') }),
    [FIELD_NAMES.DEFAULT_TIMER_TIME]: z.coerce
      .number()
      .min(1, { message: t('errors:forms.minLength', { count: 1 }) }),
    [FIELD_NAMES.MINIMUM_TIMER_TIME]: z.coerce
      .number()
      .min(2, { message: t('errors:forms.numericMin', { min: 2 }) }),
    [FIELD_NAMES.MAXIMUM_TIMER_TIME]: z.coerce
      .number()
      .min(1, { message: t('errors:forms.numericMin', { min: 1 }) }),
    [FIELD_NAMES.MINIMUM_DELAY_TIME]: z.coerce
      .number()
      .min(1, { message: t('errors:forms.numericMin', { min: 1 }) }),
    [FIELD_NAMES.MAXIMUM_DELAY_TIME]: z.coerce
      .number()
      .min(0, { message: t('errors:forms.numericMin', { min: 0 }) }),
    [FIELD_NAMES.DEFAULT_DELAY_TIME]: z.coerce
      .number()
      .min(0, { message: t('errors:forms.numericMin', { min: 0 }) }),
  })
  .superRefine((data, ctx) => {
    if (!data[FIELD_NAMES.IS_UV_EQUIPMENT] && !data[FIELD_NAMES.NON_UV_CATEGORY]) {
      ctx.addIssue({
        code: 'custom',
        message: t('errors:forms.required'),
        path: [FIELD_NAMES.NON_UV_CATEGORY],
      })
    }
  })
  .passthrough()

export const NON_UV_CATEGORY_OPTIONS = [
  { label: t('checkIn:equipments.addEquipment.nonUvCategorySpa'), value: 'spa' },
  { label: t('checkIn:equipments.addEquipment.nonUvCategorySpray'), value: 'spray' },
  { label: t('checkIn:equipments.addEquipment.nonUvCategoryWellness'), value: 'wellness' },
  { label: t('checkIn:equipments.addEquipment.nonUvCategoryRedLight'), value: 'red_light' },
]
